import { defineStore } from 'pinia'
import { store } from '@/store'
import { cloneDeep } from 'lodash-es'
import remainingRouter from '@/router/modules/remaining'

export interface PermissionState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
  menuTabRouters: AppRouteRecordRaw[]
}

export const usePermissionStore = defineStore('permission', {
  state: (): PermissionState => ({
    routers: [],
    addRouters: [],
    menuTabRouters: [],
  }),
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return this.addRouters
    },
    getMenuTabRouters(): AppRouteRecordRaw[] {
      return this.menuTabRouters
    },
  },
  actions: {
    /** 直接使用本地路由（不合并后台菜单），路由在 remaining.ts 中静态定义 */
    async generateRoutes(): Promise<unknown> {
      return new Promise<void>((resolve) => {
        // 电力用户端：路由完全由前端本地定义，不走后台菜单
        this.addRouters = []
        this.routers = cloneDeep(remainingRouter)
        resolve()
      })
    },
    setMenuTabRouters(routers: AppRouteRecordRaw[]): void {
      this.menuTabRouters = routers
    },
  },
  persist: false,
})

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}
